import axios from 'axios';
import { stringify } from 'query-string';

import {
  APPLICATION_LOADING,
  API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_REQUEST,
  API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_SUCCESS,
  API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_ERROR,
  TEMPLATE_CATEGORY_GET_DETAILS_REQUEST,
  TEMPLATE_CATEGORY_GET_DETAILS_SUCCESS,
  TEMPLATE_CATEGORY_GET_DETAILS_ERROR,
  TEMPLATE_CATEGORY_GET_REQUEST,
  TEMPLATE_CATEGORY_GET_SUCCESS,
  TEMPLATE_CATEGORY_GET_ERROR,
  TEMPLATE_CATEGORY_PUT_REQUEST,
  TEMPLATE_CATEGORY_PUT_SUCCESS,
  TEMPLATE_CATEGORY_PUT_ERROR,
  TEMPLATE_CATEGORY_POST_REQUEST,
  TEMPLATE_CATEGORY_POST_SUCCESS,
  TEMPLATE_CATEGORY_POST_ERROR,
  TEMPLATE_CATEGORY_TEMPLATES_GET_REQUEST,
  TEMPLATE_CATEGORY_TEMPLATES_GET_SUCCESS,
  TEMPLATE_CATEGORY_TEMPLATES_GET_ERROR,
  TEMPLATE_CATEGORY_APIS_ACCESS_GET_REQUEST,
  TEMPLATE_CATEGORY_APIS_ACCESS_GET_SUCCESS,
  TEMPLATE_CATEGORY_APIS_ACCESS_GET_ERROR,
  TEMPLATES_GET_REQUEST,
  TEMPLATES_GET_SUCCESS,
  TEMPLATES_GET_ERROR,
  TEMPLATE_CATEGORY_TEMPLATES_UPDATE_REQUEST,
  TEMPLATE_CATEGORY_TEMPLATES_UPDATE_SUCCESS,
  TEMPLATE_CATEGORY_TEMPLATES_UPDATE_ERROR,
  TEMPLATE_CATEGORY_LIST_ORDER_REQUEST,
  TEMPLATE_CATEGORY_LIST_ORDER_SUCCESS,
  TEMPLATE_CATEGORY_LIST_ORDER_ERROR,
  TEMPLATE_CATEGORY_GET_LIST_REQUEST,
  TEMPLATE_CATEGORY_GET_LIST_SUCCESS,
  TEMPLATE_CATEGORY_GET_LIST_ERROR,
  TEMPLATE_CATEGORY_DELETE_REQUEST,
  TEMPLATE_CATEGORY_DELETE_SUCCESS,
  TEMPLATE_CATEGORY_DELETE_ERROR,
  TEMPLATE_CATEGORY_ORGANIZATIONS_GET_SUCCESS,
  TEMPLATE_CATEGORY_ORGANIZATIONS_GET_ERROR,
  TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_REQUEST,
  TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_SUCCESS,
  TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_ERROR,
  TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_SUCCESS,
  TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_ERROR,
  TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_REQUEST,
} from '../../constants';
import { AXIOS_DEFAULT_OPTIONS, AXIOS_DEFAULT_OPTIONS_HEADERS } from '..';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import { isEmpty } from 'lodash';

const initApplication = (dispatch, isLoading = true) =>
  dispatch({
    type: APPLICATION_LOADING,
    isLoading,
  });

const buildQueryString = (params) => {
  let queryString = stringify(params, true);
  queryString = queryString ? `?${queryString}` : '';
  return queryString;
};

export const createTemplateCategory = ({ name, description, settings }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories`;

    const data = {
      name,
      description,
      settings,
    };

    dispatch({
      type: TEMPLATE_CATEGORY_POST_REQUEST,
    });
    await axios.post(url, data, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_POST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: TEMPLATE_CATEGORY_POST_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchTemplateCategory = ({ uuid }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${uuid}`;

    dispatch({
      type: TEMPLATE_CATEGORY_GET_REQUEST,
    });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: TEMPLATE_CATEGORY_GET_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const updateTemplateCategory = ({
    allowNonCompliantApisToBeUpdated,
    defaultCategory,
    description,
    enforceTemplateOrdering,
    name,
    templateUsageRestriction,
    uuid,
    criteria,
    accessType,
    flexible,
  }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${uuid}`;

    const data = {
      allowNonCompliantApisToBeUpdated,
      defaultCategory,
      description,
      enforceTemplateOrdering,
      name,
      templateUsageRestriction,
      uuid,
      criteria,
      accessType,
      flexible,
    };

    dispatch({
      type: TEMPLATE_CATEGORY_PUT_REQUEST,
    });
    await axios.put(url, data, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_PUT_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: TEMPLATE_CATEGORY_PUT_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const deleteTemplateCategory =(uuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${uuid}`;

    dispatch({
      type: TEMPLATE_CATEGORY_DELETE_REQUEST,
    });
    await axios.delete(url, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then(() => {
        dispatch({
          type: TEMPLATE_CATEGORY_DELETE_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: TEMPLATE_CATEGORY_DELETE_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchPolicyTemplates = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policyTemplates`;

    dispatch({
      type: TEMPLATES_GET_REQUEST,
    });

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: TEMPLATES_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: TEMPLATES_GET_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchCategoryTemplates = (categoryUuid, allCategoriesIds) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url =
      `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${categoryUuid}/policy-templates`;

    dispatch({
      type: TEMPLATE_CATEGORY_TEMPLATES_GET_REQUEST,
    });

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_TEMPLATES_GET_SUCCESS,
          payload: response.data,
          categoryUuid,
          allCategoriesIds,
        });
      })
      .catch((error) =>
        dispatch({
          type: TEMPLATE_CATEGORY_TEMPLATES_GET_ERROR,
          payload: getValidationErrors(error),
          allCategoriesIds,
          categoryUuid,
        }),
      );
  };

export const fetchCategoryApisAccess = ({
  categoryUuid,
  filterByName = null,
  filterByApiManagingOrg = null,
  stateFilterValue = null,
  applicableFilterValue = null,
  complianceFilterValue = null,
  assignedFilterValue = null, page = 0, rowsPerPage = 12 }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const params = stringify({
      apiNameContains: !isEmpty(filterByName) ? filterByName : undefined,
      apiManagingOrgUuid: !isEmpty(filterByApiManagingOrg) ? filterByApiManagingOrg : undefined,
      portalStatus: !isEmpty(stateFilterValue) ? stateFilterValue : undefined,
      categoryApplicability: !isEmpty(applicableFilterValue) ? applicableFilterValue : undefined,
      categoryApiCompliance: !isEmpty(complianceFilterValue) ? complianceFilterValue : undefined,
      categoryApiAccessStatus: !isEmpty(assignedFilterValue) ? assignedFilterValue : undefined,
      page,
      size: rowsPerPage,
    }, true);

    const url =
      `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/access/apis-category/${categoryUuid}?${params}`;

    dispatch({
      type: TEMPLATE_CATEGORY_APIS_ACCESS_GET_REQUEST,
    });

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_APIS_ACCESS_GET_SUCCESS,
          payload: response.data,
          categoryUuid,
        });
      })
      .catch((error) =>
        dispatch({
          type: TEMPLATE_CATEGORY_APIS_ACCESS_GET_ERROR,
          payload: getValidationErrors(error),
          categoryUuid,
        }),
      );
  };


export const fetchOrganizationsFiltered = ({ name='', size=20, pageNumber=0 }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const params = stringify({
      name: name,
      status: 'ENABLED',
      type: 'PUBLISHER',
      pageNumber,
      size,
    }, true);

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/internal/organizations?${params}`;

    dispatch({
      type: TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_REQUEST,
    });

    await axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: TEMPLATE_CATEGORY_APIS_ACCESS_ORGANIZATIONS_FILTERED_GET_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };


export const updateCategoryTemplates = (
  categoryUuid,
  fixedTemplates = [],
  flexibleTemplates = []) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url =
      `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${categoryUuid}/policy-templates`;

    dispatch({
      type: TEMPLATE_CATEGORY_TEMPLATES_UPDATE_REQUEST,
    });

    await axios.put(url, { "fixedTemplates": fixedTemplates, "flexibleTemplates": flexibleTemplates }, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_TEMPLATES_UPDATE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: TEMPLATE_CATEGORY_TEMPLATES_UPDATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchTemplateCategoryDetailsForMap = (categoryId) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${categoryId}`;

    dispatch({
      categoryId,
      type: TEMPLATE_CATEGORY_GET_DETAILS_REQUEST,
    });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          categoryId,
          payload: response.data,
          type: TEMPLATE_CATEGORY_GET_DETAILS_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          categoryId,
          payload: getValidationErrors(error),
          type: TEMPLATE_CATEGORY_GET_DETAILS_ERROR,
        });
      });
  };

export const fetchTemplateCategoryList = ( params = {} ) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const { name: searchParam } = params;
    const updatedParams = {
      ...(searchParam && { name: searchParam }),
    };
    const queryString = buildQueryString(updatedParams);
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories${queryString}`;

    dispatch({
      type: TEMPLATE_CATEGORY_GET_LIST_REQUEST,
    });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          type: TEMPLATE_CATEGORY_GET_LIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: TEMPLATE_CATEGORY_GET_LIST_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchAPIApplicableTemplateCategoryList = (uuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const updatedParams = {
      ...(uuid && { forApiUuid: uuid }),
    };
    const queryString = buildQueryString(updatedParams);
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories${queryString}`;

    dispatch({
      type: API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_REQUEST,
    });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then((response) => {
        dispatch({
          type: API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_APPLICABLE_TEMPLATE_CATEGORY_GET_LIST_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const orderTemplateCategoryList = (categoriesIds) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/order`;

    dispatch({
      type: TEMPLATE_CATEGORY_LIST_ORDER_REQUEST,
    });
    await axios.put(url, categoriesIds, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then(() => {
        dispatch({
          type: TEMPLATE_CATEGORY_LIST_ORDER_SUCCESS,
        });
      })
      .catch((error) => {
        dispatch({
          type: TEMPLATE_CATEGORY_LIST_ORDER_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };
  
  export const fetchCategoryAccessOrgs = ({ filterByName = null, categoryUuid, hasAccess,
    tags, page = 0, rowsPerPage = 12 }) =>
   async (dispatch, getState) => {
     initApplication(dispatch);
     const config = getConfig(getState());
     const { portal } = config;

     const params = stringify({
       organizationName: !isEmpty(filterByName) ? filterByName : undefined,
       categoryOrgAccessStatus: hasAccess ? 'ASSIGNED' : 'NOT_ASSIGNED',
       organizationTags: tags,
       page,
       size: rowsPerPage,
     }, true);

     const url = `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/access/organizations-category/${categoryUuid}?${params}`;
     await axios.get(url, AXIOS_DEFAULT_OPTIONS)
       .then(response =>
         dispatch({
           type: TEMPLATE_CATEGORY_ORGANIZATIONS_GET_SUCCESS,
           payload: response.data,
         }),
       )
       .catch(error =>
         dispatch({
           type: TEMPLATE_CATEGORY_ORGANIZATIONS_GET_ERROR,
           payload: getValidationErrors(error),
         }),
       );
     };

  export const updateCategoryOrgAccess = ({ categoryUuid, data, action }) =>
    async (dispatch, getState) => {
      const config = getConfig(getState());
      const { portal } = config;
      dispatch({
        type: TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_REQUEST,
      });
      const params = stringify({
        action,
      }, true);
      const url =
        `${portal.hostname}/api/${portal.tenantPrefix}/policy-management/1.0/categories/${categoryUuid}/organizations?${params}`;
      await axios.patch(url, data, AXIOS_DEFAULT_OPTIONS)
        .then((response) => {
          dispatch({
            type: TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_SUCCESS,
            payload: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: TEMPLATE_CATEGORY_ORGANIZATIONS_UPDATE_ERROR,
            payload: getValidationErrors(error),
          });
        });
    };
